// BusinessErrorsEnum: generic fallback messages used by getErrorMessage() (~25 catch blocks)
// BusinessErrors: status-code-specific messages used by switch statements (createOwner, update*Info)
export enum BusinessErrorsEnum {
  SIGN_UP_BUSINESS = 'Ошибка при регистрации бизнеса.',
  SIGN_UP_POINT = 'Ошибка при регистрации точки.',
  SIGN_UP_OWNER = 'Ошибка при регистрации.',
  SIGN_UP_ADMINISTRATOR = 'Ошибка при регистрации администратора.',
  SIGN_UP_MANAGER = 'Ошибка при регистрации менеджера.',
  SIGN_UP_EMPLOYEE = 'Ошибка при регистрации сотрудника.',
  GET_USER_INFO = 'Ошибка при получении данных пользователя.',
  GET_ACCOUNT_INFO = 'Ошибка при получении данных пользователя.',
  GET_BUSINESSES_INFO = 'Ошибка при получении данных о бизнесах владельца.',
  GET_POINTS_INFO = 'Ошибка при получении данных о точках.',
  GET_ADMINISTRATORS_INFO = 'Ошибка при получении данных о администраторах.',
  GET_EMPLOYEES_INFO = 'Ошибка при получении данных о сотрудниках.',
  GET_MANAGERS_INFO = 'Ошибка при получении данных о менеджерах.',
  UPDATE_OWNER_PROFILE_INFO = 'Ошибка при обновлении данных профиля владельца.',
  UPDATE_BUSINESS_INFO = 'Ошибка при обновлении данных бизнеса.',
  GET_BUSINESS_CARD_INFO = 'Ошибка при получении данных о шапке бизнеса.',
  GET_POINT_CARD_INFO = 'Ошибка при получении данных о шапке точки.',
  UPDATE_POINT_INFO = 'Ошибка при обновлении данных точки.',
  ACCOUNT_GET_INFO = 'Ошибка при получении данных аккаунта.',
  UPDATE_PROFILE_INFO = 'Ошибка при обновлении данных аккаунта.',
  GET_MANAGERS_ACCOUNT_LIST = 'Ошибка при получении списка менеджеров, управляющих.',
  DELETE_EMPLOYEE = 'Ошибка при удалении сотрудника.',
  DELETE_MANAGER = 'Ошибка при удалении менеджера.',
  DELETE_ADMINISTRATOR = 'Ошибка при удалении управляющего.',
  DELETE_POINT = 'Ошибка при удалении точки.',
  GET_OWNER_LICENSE_INFO = 'Ошибка при получении данных о лицензии владельца.',
  LICENSE_PAYMENT = 'Ошибка при оплате.',
  GET_PAYMENTS = 'Не удалось загрузить историю платежей',
  REFUND_CALCULATE = 'Не удалось рассчитать возврат',
  REFUND_PAYMENT = 'Не удалось выполнить возврат',
}

export const BusinessErrors = {
  CREATE_OWNER: {
    409: 'Пользователь уже существует.',
    400: 'Номер телефона или email уже используется.',
  },
  UPDATE_DATA: {
    400: 'Номер телефона или email уже используется.',
    403: 'Доступ запрещен.',
    404: 'Пользователь не найден.',
  },
};
